import axios from './axios.service'

const method = 'cookies'

class CookiesService {
  async listAll() {
    try {
      const response = await axios.get(`/${method}`)
      return response.data
    } catch (error) {
      return error
    }
  }

  async setCookies(items) {
    try {
      const response = await axios({
        method: 'post',
        url: `/${method}`,
        data: {
          items
        }
      })
      return response
    } catch (error) {
      return error
    }
  }
}

export default new CookiesService()
